import _asyncToGenerator from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import { BlockMapBuilder, EditorState, Modifier } from 'draft-js';
import { useCallback } from 'react';
import { useSiteConfig } from 'libs/common/hooks';
import { convertHTMLToContentBlocks } from '../clipboard';

var handlePastedTextAsynchronously = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var siteId, htmlOrText, state, setEditorState, setLoading, _yield$convertHTMLToC, contentBlocks, htmlMap, newState;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            siteId = _ref.siteId, htmlOrText = _ref.htmlOrText, state = _ref.state, setEditorState = _ref.setEditorState, setLoading = _ref.setLoading;
            setLoading(true);
            _context.prev = 2;
            _context.next = 5;
            return convertHTMLToContentBlocks(siteId, htmlOrText);

          case 5:
            _context.t1 = _yield$convertHTMLToC = _context.sent;
            _context.t0 = _context.t1 === null;

            if (_context.t0) {
              _context.next = 9;
              break;
            }

            _context.t0 = _yield$convertHTMLToC === void 0;

          case 9:
            if (!_context.t0) {
              _context.next = 13;
              break;
            }

            _context.t2 = void 0;
            _context.next = 14;
            break;

          case 13:
            _context.t2 = _yield$convertHTMLToC.contentBlocks;

          case 14:
            contentBlocks = _context.t2;

            if (contentBlocks) {
              htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
              newState = Modifier.replaceWithFragment(state.getCurrentContent(), state.getSelection(), htmlMap);
              setEditorState(EditorState.push(state, newState, 'insert-fragment'));
            }

          case 16:
            _context.prev = 16;
            setLoading(false);
            return _context.finish(16);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2,, 16, 19]]);
  }));

  return function handlePastedTextAsynchronously(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var useHandlePastedText = function useHandlePastedText(setEditorState, setLoading) {
  var _useSiteConfig = useSiteConfig(),
      siteId = _useSiteConfig.id;

  return useCallback(function (text, html, state) {
    // Not handle copy/paste block from DrafJs editor
    // check on DraftJS data attributes
    if (html !== undefined && (html.includes('data-editor') || html.includes('data-offset-key'))) {
      return 'not-handled';
    }

    void handlePastedTextAsynchronously({
      siteId: siteId,
      htmlOrText: html !== null && html !== void 0 ? html : text,
      state: state,
      setEditorState: setEditorState,
      setLoading: setLoading
    });
    return 'handled';
  }, [setEditorState, setLoading, siteId]);
};

export default useHandlePastedText;